const interactive = () =>
  import(/* webpackChunkName: "im~interactive" */ 'page/im/interactive')

let routes = [
  {
    path: '/im/interactive',
    component: interactive,
    meta: {
      cache: false
    }
  }
]

export default routes
